import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, UntypedFormBuilder, Form } from '@angular/forms';
import { GlobalService } from '../_services/global.service';
import { LocalStorageService } from '../_services/local-storage.service';
import { CampaignService } from '../_services/campaign.service';
import { CountryISO, SearchCountryField } from 'ngx-intl-tel-input';
import * as _ from 'underscore'
import { Router } from '@angular/router';

//Type of data that should be sent in API when will add contact details manullay
interface ContactDetail {
  candidatecontactdetailid?: number,
  type: string,
  contactdetail: string,
  contactdetailcategory: string,
  isprimary: number
}
interface userInfo {
  usernumber?: string,
  candidatenumber: string,
  enrichedFrom: string,
  data: ContactDetail[]
}


@Component({
    selector: 'app-add-contact-details-slider',
    templateUrl: './add-contact-details-slider.component.html',
    styleUrls: ['./add-contact-details-slider.component.scss'],
    standalone: false
})


export class AddContactDetailsSliderComponent implements OnInit {

  FORM_GROUP_TYPE = {
    personal: 'personalForm',
    professional: 'professionalForm',
    contact_number: 'contactForm'
  }

  /**Email campaing data i.e. {camp_target_id}, If called from email campaign candidate slider */
  @Input() emailCampData;

  /**Candidate number of candidate */
  @Input() candidateNumber;

  /**edit mode */
  @Input() editInfo;

  /**Enriched from which component */
  enrichedfrom: string = '';

  inEditMode: any = false;
  candidate_contact_detailid: any = null;

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  separateDialCode = true;

  //Count of each value- to check duplicate values
  countArray = {}
  /**pending status of add to contact api */
  isLoadingAddContact: boolean = false;


  /**
   * Master Form that contains, seperate form groups for professional email, personal email, and contact number,
   * Further each formGroup also includes form group for each row, then each row contains form control for input field and checkbox
   */
  masterForm = this.fb.group({
    professionalForm: this.fb.group({
      professional_0: this.fb.group({
        email: new UntypedFormControl(null, [Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$')]),
        isprimary: new UntypedFormControl(null, [])
      })
    }),
    personalForm: this.fb.group({
      personal_0: this.fb.group({
        email: new UntypedFormControl(null, [Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$')]),
        isprimary: new UntypedFormControl(null, [])
      })
    }),
    contactForm: this.fb.group({
      contact_0: this.fb.group({
        email: new UntypedFormControl(null, []),
        isprimary: new UntypedFormControl(null, [])
      })
    }),
  })

  //Emit event to close add-contact-details-slider
  @Output() closeComponentEvent: EventEmitter<{status: String}> = new EventEmitter();


  constructor(private fb: UntypedFormBuilder, private localstorageservice: LocalStorageService, private campaignService: CampaignService, public router: Router,
    ) { }

  ngOnInit() {
    if (this.editInfo.type) {
      this.inEditMode = true;
      const formGroup = this.masterForm.get(this.FORM_GROUP_TYPE[`${this.editInfo.type}`]) as UntypedFormGroup;
      if (this.editInfo.type === 'professional') {
        const innerControl = formGroup.controls['professional_0'];
        innerControl.patchValue({ email: this.editInfo.contactValue, isprimary: this.editInfo.isPrimary })
      }
      else if (this.editInfo.type === 'personal') {
        const innerControl = formGroup.controls['personal_0'];
        innerControl.patchValue({ email: this.editInfo.contactValue, isprimary: this.editInfo.isPrimary })
      }
      else if (this.editInfo.type === 'contact_number') {
        const innerControl = formGroup.controls['contact_0'];
        innerControl.patchValue({ email: this.editInfo.contactValue, isprimary: this.editInfo.isPrimary })
      }
      this.candidate_contact_detailid = this.editInfo.candidatecontactdetailid;
    }

    if (this.router.url) {
      if (this.router.url.includes('talentpool')) {
        this.enrichedfrom = 'talentpool';
      }
      else if (this.router.url.includes('candidate-list')) {
        this.enrichedfrom = 'all-candidates'
      }
      else if (this.router.url.includes('email-campaign')) {
        this.enrichedfrom = 'email-campaign-target-listing'
      }
      else if(this.router.url.includes('searchtoolbox-v2')) {
        this.enrichedfrom = 'searchtoolbox-v2'
      }
    }
  }


  /**
   * Extract keys to iterate via ngFor
   * @param type
   * @returns Contol Keys of form control in the form of array, so that ngFor track the formControls
   */
  formLength(type: string) {
    let formType = this.FORM_GROUP_TYPE[type];
    if (formType) {
      const outerFormGroup = this.masterForm.get(`${formType}`) as UntypedFormGroup;
      const innerFormGroup = outerFormGroup.controls;
      return Object.keys(innerFormGroup);
    }
  }

  /**
   * Insert new row in form group
   * @param type
   */
  addNewRow(type: string) {
    const uniqueId = GlobalService.generateUniqueId();
    if (type == 'professional' && this.masterForm.controls.professionalForm.status !== 'INVALID') {
      const formGroup = this.masterForm.get('professionalForm') as UntypedFormGroup;
      const isValid = this.ValidateEmailControls(formGroup);
      formGroup.setErrors({ required: isValid });

      if (!formGroup.hasError('required')) {
        formGroup.addControl(`professional_${uniqueId}`, new UntypedFormGroup({
          email: new UntypedFormControl(null, [Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$')]),
          isprimary: new UntypedFormControl(null, []),
        }));
      }
    }
    else if (type == 'personal' && this.masterForm.controls.personalForm.status !== 'INVALID') {
      const formGroup = this.masterForm.get('personalForm') as UntypedFormGroup;
      const isValid = this.ValidateEmailControls(formGroup);
      formGroup.setErrors({ required: isValid });

      if (!formGroup.hasError('required')) {
        formGroup.addControl(`personal_${uniqueId}`, new UntypedFormGroup({
          email: new UntypedFormControl(null, [Validators.pattern('^[_A-Za-z0-9-]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9-]+)*(\\.[A-Za-z]{2,})$')]),
          isprimary: new UntypedFormControl(null, []),
        }));
      }
    }
    if (type == 'contact_number' && this.masterForm.controls.contactForm.status !== 'INVALID') {
      const formGroup = this.masterForm.get('contactForm') as UntypedFormGroup;
      const isValid = this.ValidateEmailControls(formGroup);
      formGroup.setErrors({ required: isValid });

      if (!formGroup.hasError('required')) {
        formGroup.addControl(`contact_${uniqueId}`, new UntypedFormGroup({
          email: new UntypedFormControl(null, []),
          isprimary: new UntypedFormControl(null, []),
        }));
      }
    }
  }

  /**
   * Delete the formControl from the form group, which is clicked
   * @param type From Group from which control should be deleted
   * @param inputName
   * @param checkboxControl
   */
  deleteFormControl(type: string, inputName: string) {
    let formType = this.FORM_GROUP_TYPE[type];
    if (formType) {
      const formGroup = this.masterForm.get(`${formType}`) as UntypedFormGroup;
      if (this.countArray[formGroup.controls[`${inputName}`].value.email]) {
        this.countArray[formGroup.controls[`${inputName}`].value.email] -= 1;
        this.checkForDuplicates(this.countArray);
      }
      formGroup.removeControl(inputName);
    }
  }

  /**
   * Purpose of fuction is to uncheck all the check box of particular form group, ans only select one at a time,
   * Because user can only mark one email as primary
   * @param type type of form
   * @param contolName the control of formgroup which was clicked
   */
  checkboxManage(type, contolName) {
    let formType = this.FORM_GROUP_TYPE[type]
    if (formType) {
      const formGroup = this.masterForm.get(`${formType}`) as UntypedFormGroup;
      const innerFormGroup = formGroup.controls;
      Object.keys(innerFormGroup).forEach(x => {
        if (x != contolName)
          innerFormGroup[`${x}`]['controls'].isprimary.setValue(false);
      })
    }
  }

  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  /**
   * //Check for duplicate fields in current form
   * @param countArray count of each contact details
   */
  checkForDuplicates(countArray) {
    ['professionalForm', 'personalForm', 'contactForm'].forEach(formName => {
      let innerFormGroup = this.masterForm.controls[`${formName}`] as UntypedFormGroup;
      Object.keys(innerFormGroup.controls).forEach(x => {
        let tempFormGroup = innerFormGroup.controls[`${x}`];
        if(tempFormGroup?.value?.email && _.isObject(tempFormGroup.value.email) && countArray[tempFormGroup.value.email?.internationalNumber] && countArray[tempFormGroup.value.email?.internationalNumber] !==1 ){
          tempFormGroup.setErrors({ duplicate: true });
        }
        else if (tempFormGroup?.value?.email && countArray[tempFormGroup.value.email] && countArray[tempFormGroup.value.email] !== 1) {
          tempFormGroup.setErrors({ duplicate: true });
        }
        else {
          if (tempFormGroup.hasError('duplicate')) {
            delete tempFormGroup.errors['duplicate'];
            if (Object.keys(tempFormGroup.errors).length === 0) {
              tempFormGroup.setErrors(null);
            }
            tempFormGroup.updateValueAndValidity;
          }
        }
      });
    })
  }

  /**
   * Duplicate enteries with respect with existing contact forms
   * @param data an array of duplicate values got from backend
   */
  checkDuplicateWithExistingContactDetail(data){
    data.forEach(x=>{
      let formType;
      if(x.type === 'email'){
        if(x.contactdetailcategory === 'professional'){
          formType = 'professional'
        }
        else if(x.contactdetailcategory === 'personal'){
          formType = 'personal'
        }
      }else if(x.type === 'contactnumber'){
        formType = 'contact_number'
      }

      const innerFormGroup = this.masterForm.controls[(this.FORM_GROUP_TYPE[`${formType}`])] as UntypedFormGroup;
      Object.keys(innerFormGroup.controls).forEach(grpVal => {
        let tempFormGroup = innerFormGroup.controls[`${grpVal}`];
        if(tempFormGroup?.value?.email && _.isObject(tempFormGroup.value.email) && (tempFormGroup?.value?.email?.internationalNumber === x.contactdetail) ){
          tempFormGroup.setErrors({ duplicate: true });
        }
        else if (tempFormGroup?.value?.email && (tempFormGroup?.value?.email === x.contactdetail)) {
          tempFormGroup.setErrors({ duplicate: true });
        }
      });
    })

  }

  closeComponent() {
    this.closeComponentEvent.emit({status:'close'});
  }

  /**Fuction will return form control for each field, to detect error */
  masterFormErrors(type: string, groupName) {
    let formType = this.FORM_GROUP_TYPE[type];
    if (formType) {
      const innerFormGroup = this.masterForm.controls[`${formType}`] as UntypedFormGroup;
      const formControl = innerFormGroup.controls[`${groupName}`] as UntypedFormControl;
      return formControl['controls'].email;
    }
  }

  duplicateValueErrors(type: string, groupName) {
    let formType = this.FORM_GROUP_TYPE[type];
    if (formType) {
      const innerFormGroup = this.masterForm.controls[formType] as UntypedFormGroup;
      const formControl = innerFormGroup.controls[groupName] as UntypedFormControl;
      return formControl;
    }
  }
  submitDetails() {
    const userNumber = this.localstorageservice.getItem('usernumber');

    // For duplicate check;
    this.countArray = {}
    const contactInfo: userInfo = {
      enrichedFrom: this.enrichedfrom,
      candidatenumber: this.candidateNumber,
      data: []
    }
    const masterFormObj = this.masterForm.getRawValue();
    const personalEmailData = masterFormObj.personalForm;
    const professionalEmailData = masterFormObj.professionalForm;
    const contactData = masterFormObj.contactForm;

    //Professional Email
    Object.keys(professionalEmailData).forEach((x) => {
      const obj = professionalEmailData[`${x}`];
      if (obj && obj.email) {
        contactInfo.data.push({
          type: 'email',
          contactdetail: obj?.email,
          contactdetailcategory: 'professional',
          isprimary: Number(!!obj?.isprimary),
          ...(this.candidate_contact_detailid && (x === 'professional_0') && { candidatecontactdetailid: this.candidate_contact_detailid })
        });

        this.countArray[obj.email] = (this.countArray[obj.email] || 0) + 1;
      }
    })

    //Personal Email
    Object.keys(personalEmailData).forEach((x) => {
      const obj = personalEmailData[`${x}`];
      if (obj && obj.email) {
        contactInfo.data.push({
          type: 'email',
          contactdetail: obj?.email,
          contactdetailcategory: 'personal',
          isprimary: Number(!!obj?.isprimary),
          ...(this.candidate_contact_detailid && ( x==='personal_0') && {candidatecontactdetailid: this.candidate_contact_detailid})
        });

        this.countArray[obj.email] = (this.countArray[obj.email] || 0) + 1;
      }
    })

    //Contact number
    Object.keys(contactData).forEach((x) => {
      const obj = contactData[`${x}`];
      if (obj && obj.email?.internationalNumber) {
        contactInfo.data.push({
          type: 'contactnumber',
          contactdetail: obj?.email?.internationalNumber,
          contactdetailcategory: 'personal',
          isprimary: Number(!!obj?.isprimary),
          ...(this.candidate_contact_detailid &&( x==='contact_0') && {candidatecontactdetailid: this.candidate_contact_detailid})
        });

        this.countArray[obj.email.internationalNumber] = (this.countArray[obj.email.internationalNumber] || 0) + 1;
      }
    })

    this.checkForDuplicates(this.countArray);
    this.removeErrors();
    if (this.masterForm.status === 'VALID' && contactInfo.data?.length) {
      this.isLoadingAddContact = true;

      /**If component was called from email campaign slider then only campaign_target_id exist*/
      this.campaignService.addContactManually(this.emailCampData?.campaign_target_id, contactInfo, this.emailCampData?.campaign_id).subscribe((res: any) => {
        this.isLoadingAddContact = false;
        if (res && (res.statusCode === 200 || res.statusCode === 201)) {
          this.closeComponentEvent.emit({status:'contact-added-manually'});
        }
      }, (error)=>{
        //Duplicate
        if(error.error && error.status === 409){
          this.isLoadingAddContact = false;
          if(error.error.err && error.error.err?.duplicate?.data?.length){
            this.validateAllFormFields(this.masterForm);
            this.checkDuplicateWithExistingContactDetail(error.error.err.duplicate.data);
          }

        }else if(error.status === 500){
          //Something went wrong
        } else if(error.status === 406){
          this.checkForPrimary(error.error.err?.missingPrimary?.type);
          this.isLoadingAddContact = false;
        }
      })
    }
  }


  /**
   * Function used to check that atleast one entery of email should be marked as primary ( in personal email and professional email)
   * @param missingPrimary Used to check condition with existing contact details, this key should be sent from backend.
   */
  checkForPrimary(missingPrimary: string[] = []) {
    console.log('mmissing', missingPrimary);
    if (missingPrimary.length) {
      missingPrimary.map(type => {
        if (type === 'professional') {
          this.masterForm.controls['professionalForm'].setErrors({ missingPrimary: true });
        }
        else if (type === 'personal') {
          this.masterForm.controls['personalForm'].setErrors({ missingPrimary: true });
        }
      })
    }
    console.log('massterForm', this.masterForm);
  }

  // used to set error, if try's to add another field, with no values in prior fields
  ValidateEmailControls(formGroup: UntypedFormGroup) {
    let flag = false;
    Object.keys(formGroup.controls).forEach((element: any) => {
      if (!formGroup.controls[element]['controls'].email.value) {
        flag = true;
      }
    });
    return flag;
  }

  /**
   * Function will remove error if any error{required: true} at the time of click of "add another email", as because field are not mandatory
   * Also used to clear isPrimary mark error state, as it depend on backend response
   * @param formGroup
   */
  removeErrors(formGroup: UntypedFormGroup = this.masterForm) {
    ['personalForm', 'professionalForm', 'contactForm'].forEach((element: any) => {
      if(formGroup.controls[element].errors && formGroup.controls[element].hasError('required') && Object.keys(formGroup.controls[element].errors).length===1){
        formGroup.controls[element].setErrors(null);
        formGroup.updateValueAndValidity();
      }
    });

    //Reset missing primary error in personalFormGroup
    if(this.masterForm.controls.personalForm.errors?.missingPrimary){
      delete this.masterForm.controls.personalForm.errors.missingPrimary;
      if(Object.keys(this.masterForm.controls.personalForm.errors)){
        this.masterForm.controls.personalForm.setErrors(null);
      }
    }

    //Reset missing personal error in professional form group
    if(this.masterForm.controls.professionalForm.errors?.missingPrimary){
      delete this.masterForm.controls.professionalForm.errors.missingPrimary;
      if(Object.keys(this.masterForm.controls.professionalForm.errors)){
        this.masterForm.controls.professionalForm.setErrors(null);
      }
    }
  }
}
